import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { LearnMoreTooltip } from "@features/sales-v3/top-level-filters/components/learn-more-tooltip";
import { type HeaderContext } from "@tanstack/react-table";

interface TableHeaderProps<TData> {
  header: HeaderContext<TData, unknown>;
  title: string;
  description?: string;
  className?: string;
}

export const HeaderWithInfoIcon = <TData,>({
  header,
  title,
  description,
  className,
}: TableHeaderProps<TData>) => {
  return (
    <div
      onClick={(e) => {
        if (header.column.getToggleSortingHandler()) {
          const toggleSortingHandler = header.column.getToggleSortingHandler();
          if (toggleSortingHandler) {
            toggleSortingHandler(e);
          }
        }
      }}
      className="flex gap-2 items-center w-full justify-between"
    >
      <div
        className={clsx("flex gap-2 items-center justify-between w-full", {
          "justify-end": !header.column.getIsPinned(),
        })}
      >
        <span
          className={twMerge(
            "text-xs font-bold uppercase text-v2-primary pl-4 truncate",
            className,
          )}
          style={{
            width: `calc(max(var(--header-${header.header?.id}-size) * 1px, 60px))`,
          }}
        >
          {title}
        </span>
        {description && (
          <LearnMoreTooltip
            className="flex items-center"
            title={title}
            content={description}
          />
        )}
      </div>
      <div>
        {header.column.getIsSorted() ? (
          header.column.getIsSorted() === "desc" ? (
            <div className="flex w-5 h-5 p-[6px_12px] justify-center items-center gap-2.5 rounded bg-v2-highlight-information">
              <i className="fa-sharp fa-light fa-arrow-down text-v2-cosmic/600 fa-xs"></i>
            </div>
          ) : (
            <div className="flex w-5 h-5 p-[6px_12px] justify-center items-center gap-2.5 rounded bg-v2-highlight-information">
              <i className="fa-sharp fa-light fa-arrow-up text-v2-cosmic/600 fa-xs"></i>
            </div>
          )
        ) : null}
      </div>
    </div>
  );
};
